import React from 'react';
import { Input } from 'antd';
import { useField } from 'formik';
import { InputProps } from 'antd/lib/input';
import { FormItem } from './formItem';

export function TextField({
  name,
  label,
  formItemClassName,
  ...rest
}: { name: string; label?: string; formItemClassName?: string } & InputProps) {
  const [inputProps, metaProps] = useField(name);
  const showError = metaProps.touched && metaProps.error;

  return (
    <FormItem
      label={label}
      className={formItemClassName}
      validateStatus={showError ? 'error' : undefined}
      help={showError ? <li>{metaProps.error}</li> : undefined}
    >
      <Input {...rest} {...inputProps} />
    </FormItem>
  );
}
